import * as React from 'react';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { L10n } from '../../../ts/L10n/L10n';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';

export interface SpaceHeaderWithTotalItemsCountProps {
  readonly label: string;
  readonly count: number;
  readonly countUpToDate: boolean;
  readonly testId: string;
  readonly onClick: () => void;
  readonly licenseInfoBar?: () => JSX.Element;
}

export function SpaceHeaderWithTotalItemsCount(props: SpaceHeaderWithTotalItemsCountProps) {

  // Render empty count until we get an update to date count and then
  // just render a number from there on out.
  const [countUpToDate, setCountUpToDate] = React.useState(props.countUpToDate);
  React.useEffect(() => {
    if (props.countUpToDate) {
      setCountUpToDate(true);
    }
  }, [props.countUpToDate]);

  return (
    <div className={ SpaceContainerStyles.MastheadArea }>
      <div className={ExplorerStyles.SpaceHeaderContent} onClick={props.onClick}>
        <div className={ExplorerStyles.SpaceHeaderText}>{props.label}</div>
        <div className={Styles.Count} data-tb-test-id={props.testId + '-header-count'}>
          {countUpToDate ? L10n.localizedCount(props.count) : ''}
        </div>
      </div>
      {props.licenseInfoBar && props.licenseInfoBar()}
    </div>
  );
}

namespace Styles {

  export const Count = cssClass('space-header', 'count', {
    color: CommonStyles.Colors.AccessibleSecondaryTextColor,
    fontSize: '14px'
  });
}
